import Pinewood1 from "../Summarecon Bogor/Pinewood.webp"
import Pinewood2 from "../Summarecon Bogor/Pinewood.webp"

const Pinewoodimages =[
    Pinewood1,Pinewood2
]

export default Pinewoodimages;